import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { signupSearchParams } from 'router/search/signup';
import { beforeLoadSignupSubRoute, headSignupSubRoute } from 'router/utils';
import { validateLeadStatus } from 'router/validateLeadStatus';

export const Route = createFileRoute('/_signup/pricing')({
  validateSearch: zodValidator(signupSearchParams),
  head: headSignupSubRoute,
  beforeLoad: ({ context, location, preload, cause }) => {
    return beforeLoadSignupSubRoute({
      context,
      location,
      preload,
      cause,
      validateLeadStatus,
      validation: {
        validate: leadResponse => {
          const { lead } = leadResponse;

          if ((lead?.activitiesIds?.length ?? 0) === 0) {
            throw redirect({ to: '/activities' });
          }

          return true;
        },
      },
    });
  },
});
